export default {
      id: "chevron-left-usage",
      viewBox: "0 0 10 17",
      url: __webpack_public_path__ + "svgsprite.svg#chevron-left",
      toString: function () {
        return this.url;
      }
    }